import { ModuleTypeEnum } from '@scrambl/shared';
import { documentsApi } from '../api/documents.api';
import { DocumentResponse, DocumentCategory } from '@scrambl/shared';

export interface DocumentCapableModule {
  moduleType: ModuleTypeEnum;
  moduleId: string;
}

/**
 * Mixin to add document capabilities to any module
 * @param module The module to add document capabilities to
 */
export function withDocuments<T extends DocumentCapableModule>(module: T) {
  return {
    ...module,
    
    // Document management methods
    async getDocuments(): Promise<DocumentResponse[]> {
      return documentsApi.getDocuments(module.moduleType, module.moduleId);
    },

    async uploadFile(file: File, onProgress?: (progress: number) => void): Promise<DocumentResponse> {
      return documentsApi.uploadFile(module.moduleType, module.moduleId, file, onProgress);
    },

    async uploadMultipleFiles(
      files: File[],
      onProgress?: (fileIndex: number, progress: number) => void
    ): Promise<DocumentResponse[]> {
      return documentsApi.uploadMultipleFiles(module.moduleType, module.moduleId, files, onProgress);
    },

    async createLink(data: {
      url: string;
      displayName: string;
      tags?: string[];
      metadata?: Record<string, unknown>;
    }): Promise<DocumentResponse> {
      return documentsApi.createLink({
        moduleType: module.moduleType,
        moduleId: module.moduleId,
        ...data
      });
    },

    async getCategories(): Promise<DocumentCategory[]> {
      return documentsApi.getCategories(module.moduleType, module.moduleId);
    },

    async createCategory(data: {
      name: string;
      description?: string;
    }): Promise<DocumentCategory> {
      return documentsApi.createCategory({
        moduleType: module.moduleType,
        moduleId: module.moduleId,
        ...data
      });
    }
  };
}

/**
 * Type helper to add document capabilities to a module type
 */
export type WithDocuments<T extends DocumentCapableModule> = T & ReturnType<typeof withDocuments>; 